export default __webpack_public_path__ + "static/media/Avatar2.898d5572.svg";